import {Button, makeStyles, Typography} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import DynamicTitle from "../../component/DynamicTitle";
import {HeadCard} from "./component/HeadCard";
import {PaymentCard} from "./component/PaymentCard";
import {LaunchTo, NavTo} from "../../utils/AppManager";
import {Path} from "../../utils/Constant";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../store";
import {PaymentCustomCard} from "./component/PaymentCustomCard";
import {AcnColorTheme} from "../../assets/css/AcnColorTheme";
import {actions as BillerAction} from "../../store/redux/BillerRedux";
import {BillerModel, initBillerModel} from "../../models/BillerModel";
import {DeeplinkReqModel} from "../../models/QrBarCodeModel";
import axios from "axios";
import {ApiConfig, Service, ServiceApi} from "../../service/ServiceApi";
import {defaultHeight, fontUnit, heightUnit, padGinUnit} from "../../utils/DeviceManager";
const iOS = require('is-ios');

export function ChooseAmount() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [billInfo] = useSelector((state: RootState) => [
        state.billerReducer.billInfo,
    ]);
    const [bill, setBill] = useState<BillerModel>(initBillerModel())
    // const No_SERVICE = "ไม่สามารถเชื่อมต่อบริการได้ในขณะนี้ กรุณาลองใหม่อีกครั้ง"
    const No_SERVICE = "ขออภัย ไม่สามารถแสดงผลลัพธ์ได้ในขณะนี้ กรุณาลองอีกครั้ง"; //TLMSIT-7550
    const [amount, setAmount] = useState("0.00")

    useEffect(() => {
        window.document.title = "ชำระเงิน\u200E"
    }, [])

    function onSetAmount(am: string) {
        setAmount(am)
        setBill({...bill, customAmount: am})
    }

    useEffect(() => {
        setBill(billInfo)
    }, [billInfo])

    const generateDeepLink = async (bill: BillerModel) => {
        const request: DeeplinkReqModel = {
            billerCodeId: bill.billerCodeId,
            ref1: bill.ref1,
            ref2: bill.ref2,
            amount: bill.customAmount.toString(),
            channelSource: "LINE"
        }
        axios.post(ServiceApi.DEEP_LINK_GEN, request, ApiConfig)
            .then((res) => {
                return res;
            }).then(data => {
            const response = data.data
            if(data.status == 200 ){
                LaunchTo(`https://info.scb.co.th/scbeasy/easy_app_link.html?URI=${response.deeplinkUrl.toString()}&URL=${Service.DOMAIN}home`)
            } else {
                console.log("Error with status "+ data.statusText)
                NavTo(Path.expired.replace(":msg", No_SERVICE))
            }

        })
            .catch(error => {
                const errorStr = JSON.stringify(error)
                console.log(errorStr)
                NavTo(Path.expired.replace(":msg", No_SERVICE))
            })
    }

    return (
        <div className={classes.root}>
            {/* <div style={{height: heightUnit(defaultHeight*0.87), overflowY: 'auto', overflowX: 'hidden', marginRight: padGinUnit(45)}}>     */}
            <div 
                style={{
                    width: '90%',
                    height: '95vh', 
                    overflowY: 'auto', 
                    overflowX: 'hidden', 
                    marginRight: padGinUnit(45),
                    padding: "5%",
            }}>
                <div className={classes.header}>
                    <DynamicTitle title={"ชำระเงิน"} isFull={true} size={fontUnit(24)}/>
                </div>
                <Typography className={classes.subHeader}>
                    คุณกำลังจะชำระเงินของสินเชื่อ/ประกัน
                </Typography>

                <div className={classes.content}>
                    <div style={{paddingTop: 8, paddingBottom: 16,}}>
                        <HeadCard 
                            accountTypeName={bill.accountTypeName} 
                            fromChooseAmount={true}
                            channel={bill.channel}
                            loanType={bill.loanType} 
                            registeredNumber={bill.registeredNumber} 
                            amount={bill.fullAmount}
                        />
                    </div>
                    <Typography className={classes.subHeader}>
                        คุณต้องการจ่ายเป็นจำนวนเงินเท่าใด?
                    </Typography>
                    {(Number.parseInt(bill.fullAmount, 0) > 0) ?
                        <>
                            {(Number.parseInt(bill.minimumAmount, 0) > 0) ?
                                <PaymentCard title={'ชำระขั้นต่ำ'} amount={bill.minimumAmount} callBack={onSetAmount}/>
                                : <div/>
                            }
                            <PaymentCard title={'ชำระเต็ม'} amount={bill.fullAmount} callBack={onSetAmount}/>
                        </> 
                        : <div />
                    }
                    <PaymentCustomCard title={'ระบุจำนวน'} amount={amount} callBack={onSetAmount}/>
                </div>
                {/* <div className={classes.textfee}>*จำนวนเงินกู้คงเหลือจะคำนวณอัตราดอกเบี้ยใหม่ตามจำนวนเงินต้นคงเหลือ</div> */}
                <div className={classes.content}>
                    {
                        (Number.parseInt(bill.minimumAmount, 0) > 0) ? (
                            <div/>
                        ) : <div id={"height-for-min"} style={{height: heightUnit(76)}}/>
                    }
                    {
                        (Number.parseInt(bill.fullAmount, 0) > 0) ? (
                            <div/>
                        ) : <div id={"height-for-full"} style={{height: heightUnit(76)}}/>
                    }
                    <div id={"height-for-height"} style={{height: '100px'}}/>
                    {/* <div id={"height-for-height2"} style={{height: heightUnit(76)}}/> */}
                </div>
                {/* <div id={"height-for-height"} style={{height: !iOS? '350px' : ''}} /> */}

                <div className={classes.footer}>
                    <Button className={classes.button}
                            disabled={Number.parseInt(bill.customAmount, 0) < 1}
                            onClick={() => {
                                if (bill.channel == "scb") {
                                    generateDeepLink(bill).then(() => {
                                        console.log("Generating deep link")
                                    })
                                } else {
                                    const req = {...bill, custom: amount}
                                    BillerAction.setBiller(dispatch, req).then(() => {
                                        NavTo(Path.qrcode)
                                    })
                                }
                            }}>
                        ชำระเงิน
                    </Button>
                </div>
            </div>
        {/* </div> */}
        </div>
    )

}

const useStyles = makeStyles({
        root: {
            width: "100%",
            position: 'fixed', 
            overflow: "hidden",
            // padding: "20px", 
            marginTop: '-20px',
            backgroundColor: AcnColorTheme.primary
        },
        header: {
            paddingTop: 12, 
            marginBottom: 16
        },
        subHeader: {
            color: AcnColorTheme.black,
            fontSize: fontUnit(18),
            fontFamily: "Thonburi", 
            fontWeight: 'bold',
            paddingBottom: 8
        },
        content: {
            alignItems: 'center',
        },
        textfee: {
            color: AcnColorTheme.black,
            fontFamily: 'Thonburi',
            fontSize: fontUnit(14),
            fontWeight: 'bold',
            paddingTop: 8
        },
        footer: {
            display: 'flex',
            justifyContent: 'center',
            position: 'fixed',
            bottom: '0',
            left: '0',
            right: '0',
            width: '100%',
            paddingTop: '20px',
            paddingBottom: '20px',
            // height: '15%',
            backgroundColor: "white",
        },
        button: {
            width: '80%',
            backgroundColor: AcnColorTheme.secondaryRed,
            margin: 'auto',
            color: "white",
            borderRadius: 8,
            fontSize: 20,
            fontWeight: "bold",
            '&:disabled': {
                color: AcnColorTheme.white,
                opacity: 0.5           
            }
        }
    },
    {name: 'ChooseAmount'});